import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import clsx from 'clsx'
import React from 'react'

import AITripDateOrder from './AITripDateOrder'
import { Locations } from 'tripPlanner/pages/trip/GenerateTripPage'

interface Props {
  location: Locations
  id: string
  disabled?: boolean
  onDurationChange?: (locationIndex: number, newDuration: number) => void
  onDelete?: (locationIndex: number) => void
  locationIndex: number
  hasTripDates?: boolean
}

export function SortableAITripDateOrder({ location, id, disabled = false, onDurationChange, onDelete, locationIndex, hasTripDates = false }: Props) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
    setActivatorNodeRef,
  } = useSortable({
    id,
    disabled,
  })

  const style: React.CSSProperties = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={clsx({ 'is-dragging': isDragging })}
    >
      <AITripDateOrder
        location={location}
        dragHandleProps={{
          ...attributes,
          ...listeners,
          ref: setActivatorNodeRef,
        }}
        onDurationChange={onDurationChange}
        onDelete={onDelete}
        locationIndex={locationIndex}
        disabled={disabled}
        hasTripDates={hasTripDates}
      />
    </div>
  )
}

export default SortableAITripDateOrder
